import { comments } from "@/mocks/nanaData";

export default function DiscussionSection() {
  return (
    <section id="comments" className="px-4 py-14 md:px-6 md:py-16" aria-label="网友热评">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <span className="text-xs font-semibold uppercase tracking-widest text-primary-500">网友热评</span>
            <h2 className="mt-2 font-[ZCOOL_KuaiLe] text-3xl leading-snug text-foreground-950">
              大家怎么看？
              <span className="block text-primary-500">评论区见真章</span>
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-500">
              我们精选了各平台代表性与讨论度俱佳的网友评论，观点有碰撞也有共鸣。围观之余，也欢迎留下你的看法。
            </p>
            <ul className="mt-5 space-y-2 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-checkbox-circle-line text-primary-500"></i>
                只收录理性、友好的讨论精华
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-checkbox-circle-line text-primary-500"></i>
                标注来源平台与热度参考
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-checkbox-circle-line text-primary-500"></i>
                尊重原意，不做曲解与断章取义
              </li>
            </ul>
          </div>

          <div className="space-y-4 lg:col-span-3">
            {comments.map((c) => (
              <article
                key={c.id}
                className="rounded-2xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200"
              >
                <div className="flex items-start gap-3">
                  <span
                    className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-sm font-semibold text-background-50 ${c.color}`}
                  >
                    {c.user.slice(0, 1)}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <h3 className="whitespace-nowrap text-sm font-semibold text-foreground-900">{c.user}</h3>
                      <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[10px] text-secondary-700">{c.role}</span>
                      <span className="text-xs text-foreground-400">{c.time}</span>
                      <span className="ml-auto inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-background-100 px-2 py-0.5 text-[10px] text-foreground-500">
                        <i className="ri-community-line"></i>
                        {c.platform}
                      </span>
                    </div>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-700">{c.content}</p>
                    <div className="mt-3 flex items-center justify-between">
                      <span className="inline-flex items-center gap-1 rounded-full bg-primary-50 px-2.5 py-1 text-[11px] text-primary-600">
                        <i className="ri-award-line"></i>
                        {c.tag}
                      </span>
                      <button className="inline-flex cursor-pointer items-center gap-1 rounded-full bg-background-100 px-3 py-1 text-xs text-foreground-600 transition-colors hover:bg-primary-100 hover:text-primary-600">
                        <i className="ri-thumb-up-line"></i>
                        {c.likes}
                      </button>
                    </div>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}